import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCircles, setLines, setOperatorMode } from "reducer";
import { decode, isValidCode } from "utils/encodeDecode";
import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { Popup } from "components/popups/Popup";
import ConfigurationsTest from "components/configurationsTest/ConfigurationsTest";
import "./ConfigurationCode.scss";

const ConfigurationCode = () => {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [code, setCode] = useState("");
  const [hasError, setHasError] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const circles = useSelector(({ circles }) => circles);

  const numberHydraulic = circles.filter(
    (circle) => circle?.type === "hydraulic"
  ).length;
  const numberElectric = circles.filter(
    (circle) => circle?.type === "electric"
  ).length;

  const handleChange = (e) => {
    setCode(e.target.value.toUpperCase());
    if (hasError) {
      setHasError(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && code.length >= 3) {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    if (code.length >= 3) {
      if (code.toUpperCase() === "TESTCONFIG") {
        setIsPopupOpen(true);
      } else if (code.toUpperCase() === "OPERATORMODE") {
        dispatch(setOperatorMode());
        setIsVisible(false);
        setCode("");
      } else if (isValidCode(code)) {
        dispatch(setLines("hydraulic", numberHydraulic));
        dispatch(setLines("electric", numberElectric));

        const decodeCode = decode(code);
        await dispatch(setCircles(decodeCode));
        setIsVisible(false);
        setCode("");
      } else {
        setHasError(true);
        setTimeout(() => setHasError(false), 2000);
      }
    }
  };

  return (
    <div className="configuration-code">
      {isPopupOpen && (
        <Popup>
          <Icon
            className="close-popup"
            path={mdiClose}
            size={1}
            title="Close Popup"
            onClick={() => setIsPopupOpen(false)}
          />
          <ConfigurationsTest />
        </Popup>
      )}

      <div className="configuration-code__tooltip">
        <span className="text-normal">
          You have a configuration code sent to you?{" "}
        </span>
        <span className="text-link" onClick={() => setIsVisible(!isVisible)}>
          Type it here to retrieve the configuration
        </span>
      </div>

      {isVisible && (
        <div className="configuration-code__form">
          <div className="configuration-code__input-wrapper">
            <input
              className={`configuration-code__input ${
                hasError ? "has-error" : ""
              }`}
              value={code}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              placeholder="Configuration Code"
            />
            <div
              className={`configuration-code__error ${
                hasError ? "visible" : ""
              }`}
            >
              Code not valid
            </div>
          </div>
          <button
            className="configuration-code__button"
            disabled={code.length < 3}
            onClick={handleSubmit}
          >
            Retrieve Configuration
          </button>
        </div>
      )}
    </div>
  );
};

export default ConfigurationCode;
